<template>
  <div id="ViewConsultationByCompanyNameDataContainer" class="vs-con-loading__container">
    <vs-table hover-flat v-if="consultations && consultations.length"  :data="consultations">
      <template slot="thead">
        <vs-th v-text="$t('no')"></vs-th>
        <vs-th v-text="$t('member_name')"></vs-th>
        <vs-th v-text="$t('classification')"></vs-th>
        <vs-th v-text="$t('counselor')"></vs-th>
        <vs-th v-text="$t('treatment_result')"></vs-th>
        <vs-th v-text="$t('join_now')"></vs-th>
        <vs-th v-text="$t('subscription_time')"></vs-th>
        <vs-th v-text="$t('consulting_title')"></vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="key" v-for="(tr, key) in data">
          <vs-td v-text="consultationListCount - key" :data-tr-title="$t('no')"></vs-td>
          <vs-td :data-tr-title="$t('member_name')">{{ tr.member.name }}</vs-td>
          <vs-td :data-tr-title="$t('classification')">{{ tr.division.name }}</vs-td>
          <vs-td :data-tr-title="$t('counselor')">{{ tr.creator.name }}</vs-td>
          <vs-td :data-tr-title="$t('treatment_result')">{{ tr.result_type.name }}</vs-td>
          <vs-td :data-tr-title="$t('join_now')">{{ tr.getDate }}</vs-td>
          <vs-td :data-tr-title="$t('subscription_time')">{{ tr.getTime }}</vs-td>
          <vs-td :data-tr-title="$t('consulting_title')">
            <a href="#" @click="openEditConsultationPopup(tr.member.id, tr.id)">
              {{ $stringHelper.limitString(tr.title, 15) }}
            </a>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
      <div v-text="$t('no_record')"></div>
    </vs-alert>
  </div>
</template>

<script>
import Consultation from '@/models/Consultation'
import { EventBus } from '@/../eventbus'
import Utils from '@/helpers/utils'

export default {
  name: 'Shared.Consultations.Company.List',
  data () {
    return {
      initialPage: typeof this.$route.query.page !== 'undefined' && this.$route.query.page > 0 ? parseInt(this.$route.query.page) : 1,
      consultations: [],
      consultationListCount: 0
    }
  },
  mounted () {
    EventBus.$on('loadConsultationByCompanyName', this.loadList)
  },
  methods: {
    async loadList (companyName) {

      this.$vs.loading({container: '#ViewConsultationByCompanyNameDataContainer'})

      const response = await Consultation.companyList({ companyName })
      this.consultations = response.data.consultations
      this.consultationListCount = response.data.consultationListCount

      this.$vs.loading.close('#ViewConsultationByCompanyNameDataContainer > .con-vs-loading')

    },
    openEditConsultationPopup (memberId, consultationId) {
      Utils.openPopUp('window', 'edit-consultation', { id: memberId, consultationId })
    }
  }
}
</script>

<style lang="scss" scoped>
  .headless-portlet {
    padding: 25px;
    -webkit-box-shadow: 0 0 13px 0 rgba(82,63,105,.05);
    box-shadow: 0 0 13px 0 rgba(82,63,105,.05);
    background-color: #fff;
  }
</style>
